import moment from 'moment'
import Tafgeet from 'tafgeetjs'
import { toWords } from 'number-to-words'
import numeral from 'numeral'
import Big from 'big.js'

export const genericMixins = {
  computed: {
    isLangRtl() {
      return this.$store.getters['enums/rtlLangs'].includes(this.$store.getters['enums/lang'])
    },
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route).catch(() => {})
    },
    formatDate(date, format) {
      return moment(date).locale('ar').format(format)
    },
    downloadFile(res, filename) {
      const url = window.URL.createObjectURL(
        new Blob([res], {
          type: 'application/octet-stream',
        })
      )
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    searchGooglePlace(search_text) {
      return new Promise((resolve) => {
        const sessionToken = new google.maps.places.AutocompleteSessionToken()
        const service = new google.maps.places.AutocompleteService()
        service.getQueryPredictions(
          { input: search_text, sessionToken: sessionToken },
          (predictions) => {
            resolve(
              predictions?.map((each) => {
                return {
                  place_name: each.description,
                  place_id: each.place_id,
                  sessionToken: sessionToken,
                }
              })
            )
          }
        )
      })
    },
    getGoogleLatLng(data, map) {
      return new Promise((resolve) => {
        const request = {
          placeId: data?.place_id,
          fields: ['geometry'],
          sessionToken: data.sessionToken,
        }
        const google_map = new google.maps.Map(document.getElementById('google-map'), {
          center: { lat: 24.642516582053403, lng: 46.715022884817245 },
        })
        const detail_service = new google.maps.places.PlacesService(google_map)
        detail_service.getDetails(request, (place, status) => {
          if (status == google.maps.places.PlacesServiceStatus.OK) {
            const center = [place.geometry.location.lng(), place.geometry.location.lat()]
            map.flyTo({
              center: center,
              essential: true,
            })
            resolve(center)
          }
        })
      })
    },
    getGoogleRoute(start, end, map) {
      const directionsService = new google.maps.DirectionsService()
      directionsService
        .route({
          origin: { lng: start[0], lat: start[1] },
          destination: { lng: end[0], lat: end[1] },
          travelMode: google.maps.TravelMode.DRIVING,
        })
        .then(({ routes }) => {
          if (routes?.length) {
            let coordinates = routes[0].overview_path?.map((e) => {
              return [e.lng(), e.lat()]
            })
            const route = coordinates
            const geojson = {
              type: 'Feature',
              properties: {},
              geometry: {
                type: 'LineString',
                coordinates: route,
              },
            }

            if (map.getSource('route')) {
              map.getSource('route').setData(geojson)
            } else {
              map?.addLayer({
                id: 'route',
                type: 'line',
                source: {
                  type: 'geojson',
                  data: geojson,
                },
                layout: {
                  'line-join': 'round',
                  'line-cap': 'round',
                },
                paint: {
                  'line-color': '#2BCBDB',
                  'line-width': 5,
                  'line-opacity': 1,
                },
              })
            }
          }
        })
        .catch((e) => {
          console.log('Could not display directions due to: ' + e)
        })
    },
    getDistanceMatrix(start, end) {
      return new Promise((resolve) => {
        if (start && end) {
          const origin = new google.maps.LatLng(start[1], start[0])
          const destination = new google.maps.LatLng(end[1], end[0])
          const service = new google.maps.DistanceMatrixService()
          service.getDistanceMatrix(
            {
              origins: [origin],
              destinations: [destination],
              travelMode: 'DRIVING',
            },
            (response, status) => {
              if (status == 'OK') {
                const origins = response.originAddresses
                const destinations = response.destinationAddresses
                for (let i = 0; i < origins.length; i++) {
                  const results = response.rows[i].elements
                  for (let j = 0; j < results.length; j++) {
                    const element = results[j]
                    const distance = element.distance
                    const duration = element.duration
                    const from = origins[i]
                    const to = destinations[j]
                    resolve({ from, to, distance, duration })
                  }
                }
              }
            }
          )
        }
      })
    },
    convertNumbers2Arabic(string) {
      if (string) {
        return string.replace(/\d/g, (d) => '٠١٢٣٤٥٦٧٨٩'[d])
      }
    },
    convertToArabicWords(number) {
      if (number === 0) {
        return ' صفر ريال سعودي فقط لا غير'
      }

      const numberToArabicWords = new Tafgeet(parseFloat(number).toFixed(2), 'SAR').parse()
      const wordsArray = numberToArabicWords.split(' ')
      const justIndex = wordsArray.indexOf('فقط')
      if (justIndex !== -1) {
        wordsArray.splice(justIndex, 1) // إزالة كلمة "فقط"
        wordsArray.splice(-2, 0, 'فقط') // إضافتها قبل "لا غير"
      }
      return wordsArray.join(' ')
    },
    convertToEnglishWords(amount) {
      const numberInWords = toWords(Math.floor(amount))
      const fractionalPart = Math.round((amount % 1) * 100)
      const fractionalInWords = fractionalPart > 0 ? `and ${toWords(fractionalPart)} halala` : ''
      return `${numberInWords} ${'SAR'} ${fractionalInWords}`
    },
    currentDate(lang = 'en') {
      return moment(new Date()).locale(lang).utcOffset(0).format('YYYY-MM-DD')
    },
    groupBy(xs, key) {
      return xs.reduce((rv, x) => {
        ;(rv[x[key]] = rv[x[key]] || []).push(x)
        return rv
      }, {})
    },
    customSort(a, b, field) {
      const checkType = this.fields.find((f) => f.key === field)
      if (checkType) {
        switch (checkType.type) {
          case 'date':
            // Custom sorting for date using moment.js
            const dateA = moment(a[field], 'DD-MM-YYYY')
            const dateB = moment(b[field], 'DD-MM-YYYY')
            if (dateA.isBefore(dateB)) return 1
            if (dateA.isAfter(dateB)) return -1
            return 0
          case 'time':
            // Custom sorting for time using moment.js
            const timeA = moment(a[field], 'HH:mm:ss')
            const timeB = moment(b[field], 'HH:mm:ss')
            if (timeA.isBefore(timeB)) return 1
            if (timeA.isAfter(timeB)) return -1
            return 0
          case 'time with date':
            // Custom sorting for time with date using moment.js
            const dateTimeA = moment(a[field], 'DD-MM-YYYY HH:mm:ss')
            const dateTimeB = moment(b[field], 'DD-MM-YYYY HH:mm:ss')
            if (dateTimeA.isBefore(dateTimeB)) return 1
            if (dateTimeA.isAfter(dateTimeB)) return -1
            return 0

          default:
            // Check if the strings are numeric values
            const valA = a[field]
            const valB = b[field]

            // If both values are numbers (numeric strings), compare them as numbers
            const numA = parseFloat(valA)
            const numB = parseFloat(valB)

            if (!isNaN(numA) && !isNaN(numB)) {
              if (numA < numB) return 1
              if (numA > numB) return -1
              return 0
            }

            // If not numeric, do lexicographical (string) comparison
            if (valA < valB) return 1
            if (valA > valB) return -1
            return 0
        }
      }
    },
    formattedAmount(amount, digits = 2) {
      const decimalPart = '0'.repeat(digits) // e.g., '00000' if digits = 5
      const formatString = `0,0.${decimalPart}` // e.g., "0,0.00000"
      return numeral(amount).format(formatString)
    },
    reverseFormattedAmount(formattedAmount) {
      return numeral(formattedAmount).value()
    },
    isExpired(expiryTime) {
      if (!expiryTime) {
        return false
      }
      const expiry = moment.utc(expiryTime.trim()).locale('en')

      return moment.utc().locale('en').isSameOrAfter(expiry)
    },
    utcFormatDate(date) {
      const utcDate = new Date(date)
      const timezoneOffset = utcDate.getTimezoneOffset() * 60000
      const localDate = new Date(utcDate.getTime() + timezoneOffset)
      return localDate.toISOString()
    },
    roundTo(value, decimals = 2) {
      try {
        return Number(Big(value).round(decimals).toString())
      } catch {
        return 0
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    formatDateTime(dateString) {
      // Format ISO date string (2025-07-16T13:05:30.706Z) to local time format
      if (!dateString) return '---'

      try {
        const date = new Date(dateString)

        // Check if date is valid
        if (isNaN(date.getTime())) {
          return '---'
        }

        // Use local time methods to consider user's timezone
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        return `${day}-${month}-${year} | ${hours}:${minutes}`
      } catch (error) {
        return '---'
      }
    },
    toKebabCase(str) {
      // Convert string to kebab-case for translation keys
      // Examples: "Update Credit Limit" -> "update-credit-limit"
      //           "Change Contact Info" -> "change-contact-info"
      if (!str) return ''

      return str
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/[^a-z0-9-]/g, '') // Remove special characters except hyphens (escaped hyphen)
        .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
        .replace(/(^-|-$)/g, '') // Remove leading/trailing hyphens (grouped alternation)
    },
    getMonthsBetween(fromDate, toDate) {
      const start = moment.utc(fromDate, 'YYYY-MM-DD').startOf('month')
      const end = moment.utc(toDate, 'YYYY-MM-DD').startOf('month')
      const months = []
      while (start.isSameOrBefore(end)) {
        months.push(start.toDate())
        start.add(1, 'month')
      }
      return months
    },
  },
}
